import { useContext } from 'react';
import { Button, Drawer, Fab, TextField } from '@mui/material'
import React, { useState } from 'react'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import LoginContext from '../context/login_context/LoginContext';
import { AddRegistro } from '../api/AddRegistro.api';//ok
import { renderTimeViewClock } from '@mui/x-date-pickers';
import { esES } from '@mui/x-date-pickers/locales';

/** ICONS */
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SaveIcon from '@mui/icons-material/Save';
import { AddResouceH } from '../api/AddResouceH.api';

dayjs().locale('es-CL').format()
export const DrawerRegistroSelDate = ({task, ModalLoadded, setModalLoadded, setTexto, Reload_, setReload_, RegistroBulk, Reload_RH, setReload_RH}) => {
  const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);
  // console.log(LoginState.rut);

  let hoy = dayjs()
  // let a = hoy.setMinutes(hoy.getMinutes-10)
  const [value_a, setValue_a] = React.useState(dayjs().subtract(10, "minute"));
  const [value_b, setValue_b] = React.useState(dayjs());
  const [taskID, setTaskID] = React.useState(task?.id_work_orders_tasks);
  const [dataChanged, setDataChanged] = React.useState([]);

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const HandleAddRegistro = async () => {
    await setTexto('Cargando ...')
    await setModalLoadded(true)
    let add_registro = await AddRegistro({taskID:taskID, fechas:{start: new Date(value_a).getTime(), end: new Date(value_b).getTime()}, planta:LoginState.planta})

    // console.log({rut:LoginState.rut, minutos: Number(((value_b.$d - value_a.$d) / 60000).toFixed(0)), wo_folio: task.wo_folio, taskID, planta:LoginState.planta})
    let adresou = await AddResouceH({rut:LoginState.rut, minutos: (value_b.$d - value_a.$d) / 60000, wo_folio: task.wo_folio, taskID, planta:LoginState.planta})

    setReload_(Reload_ + 1)
    setReload_RH(Reload_RH + 1)
    // setDataChanged(add_registro)
    setState({ ...state, ['right']: false })
    await setModalLoadded(false)
  }

  return (
        <div className='container-fluid mt-3'>
          <div className='row'>
            <div className='col-12 text-center py-1 bg-secondary '> 
              <h5 className=' text-center text-white'>Agregar Fecha del Trabajo</h5>
            </div>
            <div className='col-12 my-2'>
              <TextField size='small' fullWidth disabled value={task.description} id="outlined-basicTarea" label="Tarea" variant="outlined" />
            </div>
            <div className='col-12 my-2'>
              <TextField size='small' fullWidth disabled value={task.user_assigned} id="outlined-basicUsuario" label="Usuario" variant="outlined" />
            </div>
            <div className='col-12'>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es-ES'} localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}>
                <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                  <DateTimePicker
                    value={value_a}
                    onChange={(newValue) => setValue_a(newValue)}
                    label="Fecha y hora inicio del trabajo"
                    ampm={false}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                      seconds: renderTimeViewClock,
                    }}
                  />
                  <DateTimePicker
                    locale={'es-ES'}
                    
                    value={value_b}
                    onChange={(newValue) => setValue_b(newValue)}
                    label="Fecha y hora fin del trabajo"
                    ampm={false}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                      seconds: renderTimeViewClock,
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
            <div className='col-12 text-center pt-4'>
              <div className='row'>
                <div className='col-12'>
                  <Button
                    /** bloque de boton si existe algun registro, se debe agregar un RR.HH con los datos del recgistro */
                  
                    disabled={RegistroBulk.length === 0?false:true}
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={()=>HandleAddRegistro()}
                  >Guardar Registro</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      
  )
}
